import React from 'react';
import { ShieldCheck, Activity, Lock } from 'lucide-react';
import { PaspampresLogo } from './PaspampresLogo';
export function FooterStrip() {
  return <footer className="mt-8 flex flex-col sm:flex-row min-h-12 py-3 sm:py-2.5 w-full items-center justify-center sm:justify-between gap-2 sm:gap-0 border-t border-border/60 bg-card/40 px-4 sm:px-6 font-mono text-[10px] text-muted-foreground text-center sm:text-left rounded-md" data-id="element-426">
      <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3 sm:gap-4" data-id="element-427">
        <span className="flex items-center gap-1.5" data-id="element-428">
          <PaspampresLogo size={16} className="size-4 shrink-0" data-id="element-429" />
          <span className="font-bold text-foreground/70 uppercase tracking-wider" data-id="element-430">
            Paspampres
          </span>
        </span>
        <span className="hidden sm:inline-flex items-center gap-1.5" data-id="element-431">
          <Activity className="size-3 text-emerald-600" data-id="element-432" />
          <span data-id="element-433">OSINT legal · UU PDP</span>
        </span>
        <span className="hidden sm:inline-flex items-center gap-1.5" data-id="element-434">
          <ShieldCheck className="size-3 text-primary" data-id="element-435" />
          Zero Trust
        </span>
        <span className="hidden md:inline-flex items-center gap-1.5" data-id="element-436">
          <Lock className="size-3" data-id="element-437" />
          Human-in-the-loop · Auditable
        </span>
      </div>
      <div className="flex items-center gap-3" data-id="element-438">
        <span className="italic text-foreground/60" data-id="element-439">Setia · Waspada</span>
        <span className="hidden sm:inline" data-id="element-440">·</span>
        <span className="font-bold text-foreground/70" data-id="element-441">v4.1.0</span>
        <span className="hidden sm:inline" data-id="element-442">·</span>
        <span className="hidden sm:inline" data-id="element-443">build 2026.05</span>
        <span className="hidden md:inline" data-id="element-444">·</span>
        <span className="hidden md:inline" data-id="element-445">
          © Pemerintah Republik Indonesia
        </span>
      </div>
    </footer>;
}